import { PlatformShortcode } from '@/utils/convert-platform'

export enum PrDistributeType {
  FollowLevel = 'FollowLevel',
  FansUpRate = 'FansUpRate',
  FansInteractiveRate = 'FansInteractiveRate',
  ViewRate = 'ViewRate',
  PublishFrequency = 'PublishFrequency',
}

interface PrThresholds {
  [prDistributeType: string]: {
    [platformShortcode: string]: {
      [key: number]: number
    }
  }
}

export const PR_DISTRIBUTE_THRESHOLDS: PrThresholds = {
  [PrDistributeType.FollowLevel]: {
    [PlatformShortcode.Facebook]: {
      10: 777,
      20: 1909,
      30: 3410,
      40: 5723,
      50: 9657,
      60: 16756,
      70: 31684,
      80: 69770,
      90: 202698,
      99: 1782221,
    },
    [PlatformShortcode.Instagram]: {
      10: 1124,
      20: 1274,
      30: 1453,
      40: 1688,
      50: 2027,
      60: 2531,
      70: 3452,
      80: 5555,
      90: 12325,
      99: 133769,
    },
    [PlatformShortcode.YouTube]: {
      10: 181,
      20: 701,
      30: 1840,
      40: 4300,
      50: 10300,
      60: 23100,
      70: 52100,
      80: 123000,
      90: 327000,
      99: 2271300,
    },
  },
  [PrDistributeType.FansUpRate]: {
    [PlatformShortcode.Facebook]: {
      10: 0.0006,
      20: 0.003,
      30: 0.0055,
      40: 0.0103,
      50: 0.015,
      60: 0.022,
      70: 0.0314,
      80: 0.0653,
      90: 0.1374,
      99: 1.0703,
    },
    [PlatformShortcode.Instagram]: {
      10: 0.0013,
      20: 0.0063,
      30: 0.0115,
      40: 0.0176,
      50: 0.0253,
      60: 0.0353,
      70: 0.0499,
      80: 0.074,
      90: 0.1319,
      99: 0.7564,
    },
    [PlatformShortcode.YouTube]: {
      10: 0.0006,
      20: 0.0096,
      30: 0.016,
      40: 0.0199,
      50: 0.0327,
      60: 0.0436,
      70: 0.0599,
      80: 0.0927,
      90: 0.1176,
      99: 0.3464,
    },
  },
  [PrDistributeType.FansInteractiveRate]: {
    [PlatformShortcode.Facebook]: {
      10: 0.0014,
      20: 0.0027,
      30: 0.0043,
      40: 0.0075,
      50: 0.0107,
      60: 0.014,
      70: 0.019,
      80: 0.0282,
      90: 0.054,
      99: 0.158,
    },
    [PlatformShortcode.Instagram]: {
      10: 0.0014,
      20: 0.0062,
      30: 0.0133,
      40: 0.0215,
      50: 0.0308,
      60: 0.0422,
      70: 0.0568,
      80: 0.0773,
      90: 0.1152,
      99: 0.2902,
    },
    [PlatformShortcode.YouTube]: {
      10: 0.0006,
      20: 0.0019,
      30: 0.0026,
      40: 0.0043,
      50: 0.0053,
      60: 0.0059,
      70: 0.0068,
      80: 0.0129,
      90: 0.0322,
      99: 0.4542,
    },
  },
  [PrDistributeType.ViewRate]: {
    [PlatformShortcode.Facebook]: {
      10: 0,
      20: 0.0032,
      30: 0.0104,
      40: 0.02,
      50: 0.0368,
      60: 0.0654,
      70: 0.1194,
      80: 0.1753,
      90: 0.5071,
      99: 4.259,
    },
    [PlatformShortcode.Instagram]: {
      10: 0.1082,
      20: 0.1921,
      30: 0.2805,
      40: 0.3802,
      50: 0.4927,
      60: 0.6303,
      70: 0.8128,
      80: 1.1131,
      90: 1.8205,
      99: 12.9975,
    },
    [PlatformShortcode.YouTube]: {
      10: 0.0379,
      20: 0.1002,
      30: 0.1173,
      40: 0.1594,
      50: 0.2682,
      60: 0.3215,
      70: 0.3589,
      80: 0.5691,
      90: 0.9468,
      99: 9.0692,
    },
  },
  [PrDistributeType.PublishFrequency]: {
    [PlatformShortcode.Facebook]: {
      10: 0,
      20: 0,
      30: 1,
      40: 3,
      50: 8,
      60: 15,
      70: 25,
      80: 43,
      90: 84,
      99: 551,
    },
    [PlatformShortcode.Instagram]: {
      10: 0,
      20: 0,
      30: 1,
      40: 3,
      50: 6,
      60: 10,
      70: 17,
      80: 28,
      90: 52,
      99: 174,
    },
    [PlatformShortcode.YouTube]: {
      10: 0,
      20: 0,
      30: 0,
      40: 0,
      50: 1,
      60: 4,
      70: 9,
      80: 18,
      90: 43,
      99: 185,
    },
  },
}
